import { NgModule } from '@angular/core';
import { KrankheitenQueryModule, RahmenAnpassungenQueryModule, UrlaubeQueryModule, ZeitenQueryModule, ZeitQueryModule, TageQueryModule, ZeitenMitarbeiterModule } from '.';

@NgModule({
  declarations: [],
  imports: [ZeitQueryModule, ZeitenQueryModule, KrankheitenQueryModule, UrlaubeQueryModule, RahmenAnpassungenQueryModule, TageQueryModule, ZeitenMitarbeiterModule],
  exports: [ZeitQueryModule, ZeitenQueryModule, KrankheitenQueryModule, UrlaubeQueryModule, RahmenAnpassungenQueryModule, TageQueryModule, ZeitenMitarbeiterModule],
})
export class ZeitenQuerysModule {}
